import type { MouseEvent, ReactNode } from 'react';

export type ProviderLinkProps = {
  name?: string | null;
  icon?: ReactNode;
  hideIcon?: boolean;
  href?: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  variant?: 'body1' | 'body1Emphasis' | 'body2' | 'body2Emphasis' | 'caption';
  color?: string;
  underline?: 'none' | 'hover' | 'always';
  noWrap?: boolean;
  'data-testid'?: string;
};

export function useProviderLink(props: ProviderLinkProps) {
  const isClickable = Boolean(props.href || props.onClick);
  const variant = props.variant ?? 'body2';
  const isCaption = variant === 'caption';
  const underline = props.underline ?? 'hover';

  function handleClick(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();
    props.onClick?.(event);
  }

  return {
    isClickable,
    variant,
    isCaption,
    underline,
    handleClick,
    displayName: props.name?.trim() || null,
  };
}
